// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-modal.new-match__form__elements__content{
    margin-left: var(--space-and-half);
    margin-right: var(--space-and-half);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0 var(--space-and-half);
    /* margin-top: var( --space-x2 ); */
}

.new-match__form__elements__content__input {
    
    margin-bottom: 0;   
    width: 100%;
    padding-top: var( --space-half-quarter );
}

.tournament-new-match__input-member {
    width: 100%;
}

.new-match__form__elements__date__input.input-field {
    margin-top: 28px;
    margin-bottom: 16px;
    padding-top: 8px;
}


.grid-modal.new-match__form__elements__field {
    margin-left: var(--space-and-half);
    margin-right: var(--space-and-half);
    grid-template-columns: 1fr 1fr;
}

.new-match__form__elements__field__input {
    margin-top: var(--space-x3) !important;
    margin-bottom: 0;
    /* padding-top: var( --space-half-quarter ); */
}

.new-match__form__elements__date.grid-modal {
    /* grid-template-columns: 1fr 1fr; */
    grid-template-columns: 1fr;
}

.new-match__form__persons__input {
    margin-left: var(--space-and-half);
    margin-right: var(--space-and-half);
}
.new-match__form__actions {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.new-match__form__submit {
    margin-left: var(--space-and-half);
}

.new-match__form__elements__time-zone__label {
    margin-top: calc(var(--space-x2) + var(--space-half));
}

.new-match__form__elements__content__input.city_input {
    display: none;
}

.new-match__form__elements__content__input.city_input .input-field-autocomplete-search__message {
    color: var(--error-color)
}

.new-match__form__elements__referee {
    margin-left: var(--space-and-half);
    margin-right: var(--space-and-half);
    margin-top: var( --space-x2 );
    margin-bottom: var( --space-x2 );
}

.new-match__form__elements__referee__btn-add {
    margin-top: var(--space-and-half);
    margin-bottom: var( --space-x2 );
}

.new-match__form__elements__referee__input-fields__column {
    display: flex;
    justify-content: space-between;
}

.tournament-new-match__input-member:first-of-type {
    margin-right: var( --space-half-quarter );
    padding-bottom: var(--space-x2);
} 

.tournament-new-match__input-member:last-of-type {
    margin-left: var( --space-half-quarter );
}

.new-match__form__elements__content .input-field-autocomplete div,
.new-match__form__elements__field .input-field-auto-search div{
    background-color: var(--white-color);
}

.new-match__form__elements__content .input-field-autocomplete .MuiFormControl-root{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}
.new-match__form__elements .input-field-autocomplete .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-endAdornment{
    border:none;
}

.new-match__form__elements__date .new-match__form__elements__date__input .input-field-input{
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    color: var(--primary-very-dark-color);
    max-height: unset;
    padding: 14px;
}

.new-match__form__elements__field__input .input-field-input{
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.city_input .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.new-match__form__elements__referee .baloa-table{
    font-weight: var(--font-medium);
    color:var(--primary-very-dark-color);
    margin: 30px 0;
}

.new-match__form__elements .input-field-autocomplete label {
    color: var( --basic-gray-color );
}

.new-match__form__elements__referee__input-fields__column label.baloa-username {
    font-style: italic;
    color: var( --basic-gray-color );
}

.new-match__form__elements_switch{
    display: flex;
    align-items: center;
    margin-left: var(--space-and-half);
    margin-top: var(--space-and-half); 
}

.new-match__form__elements_switch .baloa-table{
    color: var(--primary-very-dark-color);
}

.tournament-new-match__input-member .baloa-username,
.tournament-new-match__input-match_assigner .baloa-username {
    font-style: initial;
    color: var(--primary-very-dark-color);
}

.tournament-new-match__input-match_assigner{
    width: 49%;
}

.search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root {
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.search_members_staff_edit_content.with-payment .input-field-autocomplete .MuiInputBase-root,
.search_members_staff_edit_content.with-payment .MuiListItem-container {
    border-radius: 8px 0 0 8px;
    min-height: 59px;
}

.search_members_staff_edit_content{
    padding: var(--space-half) 0;
}

.tournament-new-match__input-member .search_members_staff_edit_content .MuiListItem-container,
.tournament-new-match__input-match_assigner .search_members_staff_edit_content .MuiListItem-container {
    background-color: var(--white-color);
}

.tournament-new-match__input-member .search_members_staff_edit_content .input-field-autocomplete div,
.tournament-new-match__input-match_assigner .tournament-edit-match__input-match_assigner .input-field-autocomplete div{
    background: var(--white-color);
}

.search_members_staff_edit_content .MuiAutocomplete-endAdornment{
    background: var(--white-color);
}

.new-match__form__elements__content__input .MuiFormControl-root .MuiInputBase-root{
    border: 1px solid var(--new-gray-background-color);
}

.new-match__form__elements__content__input .MuiFormControl-root .MuiInputBase-root,
.new-match__form__elements__content__input .MuiFormControl-root .MuiInputBase-root .MuiAutocomplete-endAdornment{
    background: var(--white-color);
}

.new-match__content__payment_settings {
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-half);
    margin: 5px var(--space-and-half) var(--space-and-half) var(--space-and-half);
}

.new-match__content_payment_title{
    margin: var(--space-and-half);
    padding-left: 10px;
}

.new-match__content_payment_title.baloa-table{
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
}

.new-match__content__payment_settings__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.new-match__content__registration{
    width: 80%;
}

.new-match__content__payment_settings__button .icon{
    grid-area: icon;
    font-size: 22px;
    margin-right: 4px;
}

.new-match__content__payment_settings__button:hover .hubicon-settings::before,
.new-match__content__payment_settings__button:focus .hubicon-settings::before{
    color: var(--white-color);
}

.new-match__content__payment_settings__saved-config {
    padding: var(--space);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: var(--space-half);
    border: 1px solid var(--new-gray-background-color);
}

.new-match__content__payment_settings__saved-config__total-fee .baloa-table-column {
    color: var(--primary-dark-color);
    margin-bottom: var(--space-half);
}

.new-match__content__payment_settings__saved-config__total-fee .baloa-username {
    color: var(--primary-very-dark-color);
}

.new-match__form_elements_input_value{
    display: flex;
    align-items: center;
}

.new-match__form_elements_input_value .MuiAutocomplete-root {
    width: 100%;
}

.new-match__form_elements_input_value .baloa-username {
    color: var(--primary-very-dark-color);
    white-space: nowrap;
    padding: var(--space) var(--space-half);
    border-top: 1px solid var(--new-gray-background-color);
    border-right: 1px solid var(--new-gray-background-color);
    border-bottom: 1px solid var(--new-gray-background-color);
    border-radius: 0 var(--space-half) var(--space-half) 0;
}

.new-match__form_elements_input_value .baloa-username.selected {
    padding: calc( var(--space) + var(--space-quarter) ) var(--space-half);
}

.new-match__content_payment_subtitle{
    margin: 0 var(--space-x2);
}

.tournament-new-match__select .select-field-input{
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    box-sizing: border-box;
    border-radius: 8px;
    height: var(--space-x3);
}

.tournament-new-match__select .select-field-label{
    font-size: 12px;
    line-height: 14px;
    color: var(--primary-very-dark-color);
}

.tournament-new-match__select .MuiInput-underline:before {
    border-bottom: none;
}

.tournament-new-match__select .MuiSelect-selectMenu{
    font-size: 13px;
    color: var(--basic-gray-color);
}

.tournament-new-match__select.day-select {
    margin: 0;
    max-width: 200px;
}

.new-match__form__elements__referee__input-fields {
    padding: 16px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 4px;
}

.new-match__form__elements__referee__input-fields__title {
    margin-bottom: 16px;
}

.new-match__form__elements__content__input .input-field-validation label,
.new-match__form__elements__date__input .input-field-label,
.new-match__selector__add label,
.new-match__selector__team label {
    font-weight: var(--font-regular);
    line-height: 16px;
    font-size: 14px;
    color: var(--primary-very-dark-color);
}

.new-match__selector__team label { 
    margin-bottom: 4px;
}

.new-match__form__elements__date__input .input-field-label {
    top: calc(14px * -1)
}

.new-match__form__elements__content__input .input-field-validation__message {
    color: var(--error-color);
}

.MuiFormControl-root.select-action-btn__container.new-match__selector__add {
    margin-top: 14px;
}

.new-match__selector__add.clear  .MuiSelect-icon {
    color: transparent;
}

.MuiFormControl-root.select-action-btn__container.new-match__selector__team {
    margin-top: 48px;
}


.MuiFormControl-root.select-action-btn__container.select-action-btn__container .MuiInputBase-root {
    border: 1px solid var(--new-gray-background-color);
    min-height: 50px;
    color: var(--basic-gray-color);
    padding-left: 8px;
}

.MuiFormControl-root.select-action-btn__container.new-match__selector__add.day {
    max-width: 250px;
}

.tournament-new-match__local-team.input-field-autocomplete.MuiFormControl-marginNormal {
    margin: 48px 0;
}

.new-match__selector__add .select-action-btn__container .MuiInputBase-root {
    padding: 8px;
}

/* .new-match__form__elements__date__input .input-field-input {
    color: var(--white-color);
} */

.new-match__form__elements__date__input_selected_date {
    display: flex;
    align-items: center;
    position: relative;
    margin-left: 20px;
    background: var(--white-color);
    background: var(--white-color);
    top: -56px;
    margin-right: 5px;
}

.new-match__form__elements__date__input_selected_date .baloa-table{
    color:  var(--primary-very-dark-color);
}

.new-match__form__elements__date__input_selected_date__icon {
    margin-left: auto;
    background: var(--new-gray-background-color);
    border-radius: 50%;
    padding: 2px;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.new-match__form__elements__date__input_selected_date .hubicon-clear_option {
    cursor: pointer;
}

.new-match__form__elements__date.clear .new-match__form__elements__date__input .input-field-input{
    color: var(--white-color);
}

.new-match__form__elements__date__input.clear .input-field-input[type="datetime-local"]::-webkit-calendar-picker-indicator {
    filter: invert(1);
    border-radius: 50%;
    padding: 4px;
}

.new-match__form__elements__input_field {
    display: flex;
    align-items: center;
    position: relative;
    margin-left: 20px;
    top: -38px;
    margin-right: 7px;
}

.new-match__form__elements__input_day {
    display: flex;
    align-items: center;
    position: relative;
    top: -36px;
    margin-right: 5px;
    max-width: 245px;
}
.new-match__form__elements__content .select-tournament-team__container .MuiSelect-selectMenu {
    color: var(--primary-very-dark-color);
}

.new-match__form__elements__content .MuiTypography-colorTextSecondary {
    color: var(--primary-dark-color);
}

/* #menu-local_team .MuiPaper-root, #menu-visitant_team .MuiPaper-root {
    top: 10px !important;
} */

@media screen and ( min-width: 1441px ) {
    .modal2__container {
        width: 60%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-new-match-modal/TournamentNewMatchModal.styles.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,aAAa;IACb,8BAA8B;IAC9B,iCAAiC;IACjC,mCAAmC;AACvC;;AAEA;;IAEI,gBAAgB;IAChB,WAAW;IACX,wCAAwC;AAC5C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;AACvC;AACA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,kBAAkB;IAClB,qCAAqC;IACrC,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;;IAEI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kDAAkD;AACtD;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,kDAAkD;IAClD,gCAAgC;IAChC,6EAA6E;AACjF;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,yDAAyD;AAC7D;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,uCAAuC;IACvC,sDAAsD;IACtD,wDAAwD;IACxD,yDAAyD;IACzD,sDAAsD;AAC1D;;AAEA;IACI,sEAAsE;AAC1E;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;IAClD,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;IAII,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,kDAAkD;IAClD,gBAAgB;IAChB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,8BAA8B;IAC9B,8BAA8B;IAC9B,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,4CAA4C;IAC5C,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;GAEG;;AAEH;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".grid-modal.new-match__form__elements__content{\n    margin-left: var(--space-and-half);\n    margin-right: var(--space-and-half);\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 0 var(--space-and-half);\n    /* margin-top: var( --space-x2 ); */\n}\n\n.new-match__form__elements__content__input {\n    \n    margin-bottom: 0;   \n    width: 100%;\n    padding-top: var( --space-half-quarter );\n}\n\n.tournament-new-match__input-member {\n    width: 100%;\n}\n\n.new-match__form__elements__date__input.input-field {\n    margin-top: 28px;\n    margin-bottom: 16px;\n    padding-top: 8px;\n}\n\n\n.grid-modal.new-match__form__elements__field {\n    margin-left: var(--space-and-half);\n    margin-right: var(--space-and-half);\n    grid-template-columns: 1fr 1fr;\n}\n\n.new-match__form__elements__field__input {\n    margin-top: var(--space-x3) !important;\n    margin-bottom: 0;\n    /* padding-top: var( --space-half-quarter ); */\n}\n\n.new-match__form__elements__date.grid-modal {\n    /* grid-template-columns: 1fr 1fr; */\n    grid-template-columns: 1fr;\n}\n\n.new-match__form__persons__input {\n    margin-left: var(--space-and-half);\n    margin-right: var(--space-and-half);\n}\n.new-match__form__actions {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.new-match__form__submit {\n    margin-left: var(--space-and-half);\n}\n\n.new-match__form__elements__time-zone__label {\n    margin-top: calc(var(--space-x2) + var(--space-half));\n}\n\n.new-match__form__elements__content__input.city_input {\n    display: none;\n}\n\n.new-match__form__elements__content__input.city_input .input-field-autocomplete-search__message {\n    color: var(--error-color)\n}\n\n.new-match__form__elements__referee {\n    margin-left: var(--space-and-half);\n    margin-right: var(--space-and-half);\n    margin-top: var( --space-x2 );\n    margin-bottom: var( --space-x2 );\n}\n\n.new-match__form__elements__referee__btn-add {\n    margin-top: var(--space-and-half);\n    margin-bottom: var( --space-x2 );\n}\n\n.new-match__form__elements__referee__input-fields__column {\n    display: flex;\n    justify-content: space-between;\n}\n\n.tournament-new-match__input-member:first-of-type {\n    margin-right: var( --space-half-quarter );\n    padding-bottom: var(--space-x2);\n} \n\n.tournament-new-match__input-member:last-of-type {\n    margin-left: var( --space-half-quarter );\n}\n\n.new-match__form__elements__content .input-field-autocomplete div,\n.new-match__form__elements__field .input-field-auto-search div{\n    background-color: var(--white-color);\n}\n\n.new-match__form__elements__content .input-field-autocomplete .MuiFormControl-root{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n.new-match__form__elements .input-field-autocomplete .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"] .MuiAutocomplete-endAdornment{\n    border:none;\n}\n\n.new-match__form__elements__date .new-match__form__elements__date__input .input-field-input{\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    color: var(--primary-very-dark-color);\n    max-height: unset;\n    padding: 14px;\n}\n\n.new-match__form__elements__field__input .input-field-input{\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.city_input .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"]{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.new-match__form__elements__referee .baloa-table{\n    font-weight: var(--font-medium);\n    color:var(--primary-very-dark-color);\n    margin: 30px 0;\n}\n\n.new-match__form__elements .input-field-autocomplete label {\n    color: var( --basic-gray-color );\n}\n\n.new-match__form__elements__referee__input-fields__column label.baloa-username {\n    font-style: italic;\n    color: var( --basic-gray-color );\n}\n\n.new-match__form__elements_switch{\n    display: flex;\n    align-items: center;\n    margin-left: var(--space-and-half);\n    margin-top: var(--space-and-half); \n}\n\n.new-match__form__elements_switch .baloa-table{\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-new-match__input-member .baloa-username,\n.tournament-new-match__input-match_assigner .baloa-username {\n    font-style: initial;\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-new-match__input-match_assigner{\n    width: 49%;\n}\n\n.search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root {\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.search_members_staff_edit_content.with-payment .input-field-autocomplete .MuiInputBase-root,\n.search_members_staff_edit_content.with-payment .MuiListItem-container {\n    border-radius: 8px 0 0 8px;\n    min-height: 59px;\n}\n\n.search_members_staff_edit_content{\n    padding: var(--space-half) 0;\n}\n\n.tournament-new-match__input-member .search_members_staff_edit_content .MuiListItem-container,\n.tournament-new-match__input-match_assigner .search_members_staff_edit_content .MuiListItem-container {\n    background-color: var(--white-color);\n}\n\n.tournament-new-match__input-member .search_members_staff_edit_content .input-field-autocomplete div,\n.tournament-new-match__input-match_assigner .tournament-edit-match__input-match_assigner .input-field-autocomplete div{\n    background: var(--white-color);\n}\n\n.search_members_staff_edit_content .MuiAutocomplete-endAdornment{\n    background: var(--white-color);\n}\n\n.new-match__form__elements__content__input .MuiFormControl-root .MuiInputBase-root{\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.new-match__form__elements__content__input .MuiFormControl-root .MuiInputBase-root,\n.new-match__form__elements__content__input .MuiFormControl-root .MuiInputBase-root .MuiAutocomplete-endAdornment{\n    background: var(--white-color);\n}\n\n.new-match__content__payment_settings {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-half);\n    margin: 5px var(--space-and-half) var(--space-and-half) var(--space-and-half);\n}\n\n.new-match__content_payment_title{\n    margin: var(--space-and-half);\n    padding-left: 10px;\n}\n\n.new-match__content_payment_title.baloa-table{\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n}\n\n.new-match__content__payment_settings__container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.new-match__content__registration{\n    width: 80%;\n}\n\n.new-match__content__payment_settings__button .icon{\n    grid-area: icon;\n    font-size: 22px;\n    margin-right: 4px;\n}\n\n.new-match__content__payment_settings__button:hover .hubicon-settings::before,\n.new-match__content__payment_settings__button:focus .hubicon-settings::before{\n    color: var(--white-color);\n}\n\n.new-match__content__payment_settings__saved-config {\n    padding: var(--space);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: var(--space-half);\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.new-match__content__payment_settings__saved-config__total-fee .baloa-table-column {\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-half);\n}\n\n.new-match__content__payment_settings__saved-config__total-fee .baloa-username {\n    color: var(--primary-very-dark-color);\n}\n\n.new-match__form_elements_input_value{\n    display: flex;\n    align-items: center;\n}\n\n.new-match__form_elements_input_value .MuiAutocomplete-root {\n    width: 100%;\n}\n\n.new-match__form_elements_input_value .baloa-username {\n    color: var(--primary-very-dark-color);\n    white-space: nowrap;\n    padding: var(--space) var(--space-half);\n    border-top: 1px solid var(--new-gray-background-color);\n    border-right: 1px solid var(--new-gray-background-color);\n    border-bottom: 1px solid var(--new-gray-background-color);\n    border-radius: 0 var(--space-half) var(--space-half) 0;\n}\n\n.new-match__form_elements_input_value .baloa-username.selected {\n    padding: calc( var(--space) + var(--space-quarter) ) var(--space-half);\n}\n\n.new-match__content_payment_subtitle{\n    margin: 0 var(--space-x2);\n}\n\n.tournament-new-match__select .select-field-input{\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    box-sizing: border-box;\n    border-radius: 8px;\n    height: var(--space-x3);\n}\n\n.tournament-new-match__select .select-field-label{\n    font-size: 12px;\n    line-height: 14px;\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-new-match__select .MuiInput-underline:before {\n    border-bottom: none;\n}\n\n.tournament-new-match__select .MuiSelect-selectMenu{\n    font-size: 13px;\n    color: var(--basic-gray-color);\n}\n\n.tournament-new-match__select.day-select {\n    margin: 0;\n    max-width: 200px;\n}\n\n.new-match__form__elements__referee__input-fields {\n    padding: 16px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 4px;\n}\n\n.new-match__form__elements__referee__input-fields__title {\n    margin-bottom: 16px;\n}\n\n.new-match__form__elements__content__input .input-field-validation label,\n.new-match__form__elements__date__input .input-field-label,\n.new-match__selector__add label,\n.new-match__selector__team label {\n    font-weight: var(--font-regular);\n    line-height: 16px;\n    font-size: 14px;\n    color: var(--primary-very-dark-color);\n}\n\n.new-match__selector__team label { \n    margin-bottom: 4px;\n}\n\n.new-match__form__elements__date__input .input-field-label {\n    top: calc(14px * -1)\n}\n\n.new-match__form__elements__content__input .input-field-validation__message {\n    color: var(--error-color);\n}\n\n.MuiFormControl-root.select-action-btn__container.new-match__selector__add {\n    margin-top: 14px;\n}\n\n.new-match__selector__add.clear  .MuiSelect-icon {\n    color: transparent;\n}\n\n.MuiFormControl-root.select-action-btn__container.new-match__selector__team {\n    margin-top: 48px;\n}\n\n\n.MuiFormControl-root.select-action-btn__container.select-action-btn__container .MuiInputBase-root {\n    border: 1px solid var(--new-gray-background-color);\n    min-height: 50px;\n    color: var(--basic-gray-color);\n    padding-left: 8px;\n}\n\n.MuiFormControl-root.select-action-btn__container.new-match__selector__add.day {\n    max-width: 250px;\n}\n\n.tournament-new-match__local-team.input-field-autocomplete.MuiFormControl-marginNormal {\n    margin: 48px 0;\n}\n\n.new-match__selector__add .select-action-btn__container .MuiInputBase-root {\n    padding: 8px;\n}\n\n/* .new-match__form__elements__date__input .input-field-input {\n    color: var(--white-color);\n} */\n\n.new-match__form__elements__date__input_selected_date {\n    display: flex;\n    align-items: center;\n    position: relative;\n    margin-left: 20px;\n    background: var(--white-color);\n    background: var(--white-color);\n    top: -56px;\n    margin-right: 5px;\n}\n\n.new-match__form__elements__date__input_selected_date .baloa-table{\n    color:  var(--primary-very-dark-color);\n}\n\n.new-match__form__elements__date__input_selected_date__icon {\n    margin-left: auto;\n    background: var(--new-gray-background-color);\n    border-radius: 50%;\n    padding: 2px;\n    width: 25px;\n    height: 25px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.new-match__form__elements__date__input_selected_date .hubicon-clear_option {\n    cursor: pointer;\n}\n\n.new-match__form__elements__date.clear .new-match__form__elements__date__input .input-field-input{\n    color: var(--white-color);\n}\n\n.new-match__form__elements__date__input.clear .input-field-input[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n    filter: invert(1);\n    border-radius: 50%;\n    padding: 4px;\n}\n\n.new-match__form__elements__input_field {\n    display: flex;\n    align-items: center;\n    position: relative;\n    margin-left: 20px;\n    top: -38px;\n    margin-right: 7px;\n}\n\n.new-match__form__elements__input_day {\n    display: flex;\n    align-items: center;\n    position: relative;\n    top: -36px;\n    margin-right: 5px;\n    max-width: 245px;\n}\n.new-match__form__elements__content .select-tournament-team__container .MuiSelect-selectMenu {\n    color: var(--primary-very-dark-color);\n}\n\n.new-match__form__elements__content .MuiTypography-colorTextSecondary {\n    color: var(--primary-dark-color);\n}\n\n/* #menu-local_team .MuiPaper-root, #menu-visitant_team .MuiPaper-root {\n    top: 10px !important;\n} */\n\n@media screen and ( min-width: 1441px ) {\n    .modal2__container {\n        width: 60%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
